import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FavouriteFilledIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M31.966 12.1c-0.068-0.226-0.271-0.373-0.508-0.373h-11.333l-3.612-11.355c-0.068-0.226-0.271-0.372-0.508-0.372s-0.44 0.147-0.508 0.372l-3.612 11.355h-11.355c-0.226 0-0.429 0.147-0.508 0.361-0.068 0.214 0 0.463 0.181 0.598l9.109 6.863-3.962 11.739c-0.079 0.226 0 0.463 0.192 0.598 0.090 0.068 0.203 0.102 0.316 0.102s0.226-0.034 0.316-0.102l9.82-7.235 9.82 7.235c0.192 0.135 0.44 0.135 0.632 0s0.271-0.372 0.192-0.598l-3.928-12.066 9.064-6.535c0.192-0.124 0.271-0.361 0.192-0.587z"></path>
    </SVG>
  );
};
